var map = {
	"./de/mecha-active-btn.png": "kjry",
	"./en/mecha-active-btn.png": "O0xT",
	"./es/mecha-active-btn.png": "fg6b",
	"./fr/mecha-active-btn.png": "CuFs",
	"./ja/mecha-active-btn.png": "lkG1",
	"./ko/mecha-active-btn.png": "WwAQ",
	"./pt/mecha-active-btn.png": "RBuQ",
	"./ru/mecha-active-btn.png": "08Vi",
	"./tc/mecha-active-btn.png": "sLOt",
	"./th/mecha-active-btn.png": "E4mh"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Gzxb";